import baseStoreDefaults from '../asfir-4x4/config.js';

const getActiveCurrency = () => window.Convermax.Shopify?.getCurrency();

function formatPrice(price) {
  if (!price) {
    return '';
  }

  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: getActiveCurrency(),
  }).format(price);
}

export default {
  ...baseStoreDefaults,
  includes: [...baseStoreDefaults.includes, 'asfir-4x4'],
  product: {
    ...baseStoreDefaults.product,
    formatPrice,
  },
};
